import { render, staticRenderFns } from "./addPersonalObligee.vue?vue&type=template&id=df319b40&scoped=true&"
import script from "./addPersonalObligee.vue?vue&type=script&lang=js&"
export * from "./addPersonalObligee.vue?vue&type=script&lang=js&"
import style0 from "./addPersonalObligee.vue?vue&type=style&index=0&lang=less&"
import style1 from "./addPersonalObligee.vue?vue&type=style&index=1&id=df319b40&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df319b40",
  null
  
)

export default component.exports